import { RemoteAdminFiscalNote } from "../../../../data/usecases/fiscal-note/remote-admin-fiscal-note";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteAdminFiscalNote = (): RemoteAdminFiscalNote =>
  new RemoteAdminFiscalNote("/admin/fiscal-note", makeAxiosHttpClient());
